<template>
  <div>
    <page-title heading="Profil Dokter Praktik" :breadcrumb="[
      {
        label: 'Profil Dokter Praktik',
        link: '/profile',
        active: true
      },
    ]" class="layout-gantung ninja0-shadow" />
    <div class="container-fluid">
      <div class="card card-box mb-3 ninja-shadow">
        <div class="card-body">

          <div class="col-md-12 no-padding">
            <div class="col-md-12 text-center">
              <template>
                <picture-input :customStrings="{
                  change: 'Ubah Foto',
                  remove: 'Hapus Foto',
                  drag: 'Klik untuk memilih file foto',
                  fileSize: 'File maksimal foto',
                  fileType: 'Jenis file ini tidak didukung'
                }" ref="pictureInput" :alertOnError="false" @change="onChangeImage" width="180" height="180"
                  accept="image/jpeg,image/png" size="1" buttonClass="btn btn-primary button primary"
                  removeButtonClass="btn btn-secondary button secondary" radius="50" z-index="0"
                  :disabled="btnDisable == true" :removable="true" :prefill="dataProfile.foto_profile" />
                <label>Maks. 1 MB, File: jpeg, jpg, png</label>
              </template>
            </div>
            <div class="row mt-3">
              <div class="col-md-6">
                <b-form-group novalidate="true" label-for="input-1">
                  <label>Nama Dokter</label>
                  <label style="color:red"> *</label>
                  <b-form-input v-model="dataProfile.nama" maxlength="50" :disabled="btnDisable == true" id="input-1"
                    type="text" required>
                  </b-form-input>
                  <template v-if="dataProfile.nama === ''">
                    <label style="color: red">Nama Dokter harus diisi</label>
                  </template>

                </b-form-group>
                <b-form-group :state="getDataError({ rawLabel: 'jenis kelamin' })" :invalid-feedback="renderInvalidFeedback({
                  validationDesc: blindlyGetData({
                    rawLabel: 'jenis kelamin'
                  })
                })
                  ">
                  <label>{{ renderLabel({ label: 'Jenis kelamin' }) }}</label>
                  <label style="color:red"> *</label>
                  <b-form-radio-group v-model="dataProfile.jenis_kelamin" stacked @change="
                    setValue({
                      rawLabel: 'jenis kelamin',
                      $event
                    })

                    " class="text-capitalize" :options="[
    { text: 'laki-laki', value: 1 },
    { text: 'perempuan', value: 0 }
  ]" :disabled="btnDisable == true" :checked="getValue('jenis kelamin')">
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group>
                  <label>No. Handphone</label>
                  <label style="color:red"> *</label>
                  <b-form-input v-model="dataProfile.nomor_telp" @input="cekValueNotelp(dataProfile.nomor_telp)"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
                    :disabled="btnDisable == true" :maxlength="15">
                  </b-form-input>
                  <template v-if="dataProfile.nomor_telp.length < 10">
                    <label style="color: red">Nomor telepon minimal 10 karakter</label>
                  </template>
                  <template v-else-if="dataProfile.nomor_telp.length > 15">
                    <label style="color: red">Nomor telepon maksimal 15 karakter</label>
                  </template>
                  <template
                    v-else-if="this.validasiNotelp === 'phone is already in use!' && this.dataProfile.nomor_telp !== this.nohpBefore">
                    <label style="color: red">Nomor telepon sudah digunakan</label>
                  </template>
                  <template
                    v-else-if="btnDisable == false && this.validasiNotelp !== 'phone is already in use!' && this.inChange === true">
                    <label style="color: #1bc943">Nomor telepon dapat digunakan</label>
                  </template>

                </b-form-group>
                <b-form-group label="Email" label-for="input-1">
                  <b-form-input v-model="dataProfile.email" disabled type="email" required />
                </b-form-group>
                <b-form-group>
                  <label>
                    No. Telepon Tempat Praktik
                    <b-badge class="badge-alert" id="popover-info">
                      <font-awesome-icon icon="info" class="text-black-50" />
                    </b-badge>
                    <b-popover target="popover-info" triggers="hover" placement="bottomright">
                      <small>No. Telepon akan dicantumkan pada struk pembayaran, pesan reminder konsultasi, dan
                        lainnya</small>
                    </b-popover>
                  </label>
                  <b-form-input v-model="dataProfile.klinik.nomor_telp_engagement"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
                    :disabled="btnDisable == true" :maxlength="14">
                  </b-form-input>
                  <template
                    v-if="dataProfile.klinik.nomor_telp_engagement != null && dataProfile.klinik.nomor_telp_engagement != ''">
                    <template v-if="dataProfile.klinik.nomor_telp_engagement.length < 10">
                      <label style="color: red">Nomor telepon minimal 10 karakter</label>
                    </template>
                    <template v-else-if="dataProfile.klinik.nomor_telp_engagement.length > 14">
                      <label style="color: red">Nomor telepon maksimal 14 karakter</label>
                    </template>
                  </template>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Spesialisasi" label-for="input-1">
                  <vue-select v-model="userSpesialisasi" :disabled="btnDisable == true" :options="spesialisasi"
                    @input="getSpesialisasi" />
                </b-form-group>
                <b-form-group label="No. SIP" label-for="input-1">
                  <b-form-input v-model="dataProfile.klinik.nomor_ijin" :disabled="btnDisable == true" id="input-1"
                    type="text" maxlength="50">
                  </b-form-input>
                </b-form-group>

                <b-form-group label-for="input-1">
                  <label>Alamat Praktik </label>
                  <label style="color:red"> *</label>
                  <b-form-textarea v-model="dataProfile.klinik.alamat" :disabled="btnDisable == true" id="input-1"
                    rows="3" max-rows="6" maxlength="150">
                  </b-form-textarea>
                  <label style="color: red"
                    v-if="(dataProfile.klinik.alamat == null && btnDisable == false) || dataProfile.klinik.alamat == ''">Alamat
                    Praktik wajib diisi!</label>
                </b-form-group>
                <b-form-group class="text-capitalize" style="position: relative"
                  :state="getDataError({ rawLabel: 'provinsi' })" :invalid-feedback="renderInvalidFeedback({
                    validationDesc: blindlyGetData({
                      rawLabel: 'provinsi'
                    })
                  })
                    ">
                  <label>Provinsi </label>
                  <label style="color:red"> *</label>
                  <vue-select v-model="tempat.provinsi" :disabled="btnDisable == true" :options="provinces"
                    @input="getCity" />
                  <label style="color: red" v-if="((this.tempat.provinsi == null && btnDisable == false))">Provinsi wajib
                    diisi!</label>
                </b-form-group>
                <b-form-group class="text-capitalize" style="position: relative"
                  :state="getDataError({ rawLabel: 'kota' })" :invalid-feedback="renderInvalidFeedback({
                    validationDesc: blindlyGetData({
                      rawLabel: 'kota'
                    })
                  })
                    ">
                  <label tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">
                    kota<span class="text-danger">*</span>
                  </label>
                  <vue-select :disabled="btnDisable == true" :options="cities" v-model="tempat.kota"
                    @input="setDataTempat" />
                  <label style="color: red" v-if="tempat.kota == null && btnDisable == false">Kota wajib diisi!</label>
                </b-form-group>
                <template v-if="btnDisable == true">
                  <b-button @click="btnDisable = false" type="submit" variant="primary"
                    class="text-capitalize my-2 float-right">EDIT PROFIL</b-button>
                </template>
                <template v-else>
                  <b-button type="submit" @click="updateProses" variant="primary"
                    class="text-capitalize my-2 float-right">SIMPAN PROFIL</b-button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  EventBus
} from '../../event-bus';
import PictureInput from 'vue-picture-input'
import startCase from "lodash/startCase";
import moment from "moment";
import { mapGetters } from 'vuex'
moment.locale('id');
import {
  library
} from "@fortawesome/fontawesome-svg-core";
import {
  faInfo
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faInfo
);

export default {
  components: {
    PictureInput,
    "vue-select": () => import("@/components/VueSelectClearable.vue")
  },
  data: () => {
    return {
      errors: [],
      validasiNotelp: null,
      dataProfile: null,
      inChange: false,
      nohpBefore: null,
      btnDisable: true,
      imageProps: {
        width: 75,
        height: 75
      },
      spesialisasi: null,
      userSpesialisasi: null,
      checkValueNik: null,
      cities: [],
      provinces: null,
      image: null,
      tempat: {
        provinsi: null,
        kota: null,
      },
      prefillImage: null
    }
  },
  beforeRouteLeave(to, from, next) {

    if (to.name == "login-page") {
      this.$router.go('/login');
    }

    if (!this.beingSubmit && localStorage.getItem('IDLE') != 1) {

      if (this.btnDisable == false && this.dataProfile.klinik.alamat == null || this.dataProfile.klinik.alamat == '') {
        this.$swal({
          text: `Silakan lengkapi kolom yang wajib terisi!`,
          type: "error",
          showCancelButton: false,
          confirmButtonText: startCase("OK")
        });
        return;
      } else {
        next();
      }

      if (this.btnDisable == false && !this.tempat.provinsi && !this.tempat.kota) {
        this.$swal({
          text: `Silakan lengkapi kolom yang wajib terisi!`,
          type: "error",
          showCancelButton: false,
          confirmButtonText: startCase("OK")
        });
        return;
      } else {
        next();
      }

      if (this.btnDisable == false && this.tempat.provinsi && !this.tempat.kota) {
        this.$swal({
          text: `Silakan lengkapi kolom yang wajib terisi!`,
          type: "error",
          showCancelButton: false,
          confirmButtonText: startCase("OK")
        });
        return;
      } else {
        next();
      }

    } else {
      next();
    }
  },
  mounted() {
    this.getProvince();
    this.getSpesialisasi();
    this.getProfile();
    this.cekPaketNolock();
  },
  computed: {
    ...mapGetters(["getKlinikId"]),
  },
  watch: {
    dataProfile: {
      handler: function (val) {
        if (val) {
          this.fetchImg()
        }
      },
      deep: true
    }
  },
  methods: {
    fetchImg() {
      fetch(this.dataProfile.foto_profile)
        .then(response => response.blob())
        .then(images => {
          const x = URL.createObjectURL(images)
          this.prefillImage = x
        })
    },
    cekValueNotelp(ceknotelp) {
      if (ceknotelp.length < 15 && ceknotelp.length > 8) {
        this.inChange = true;
        if (this.timeVerifyPhone) clearTimeout(this.timeVerifyPhone)
        return new Promise((resolve, reject) => {
          this.timeVerifyPhone = setTimeout(() => {
            this.$axios.get(`phone/verify?nomor_telp=${ceknotelp}`)
              .then(res => {
                const {
                  data: {
                    status,
                    message
                  }
                } = res;
                this.validasiNotelp = res.data.message
                resolve(status);
              })
              .catch(err => {

              },)
            resolve(true);
          });
        }, 5000);
      }
    },
    async getProfile() {
      try {
        var profile = this.$store.state.user.id
        const res = await this.$axios.get(`user/${profile}?klinik_id=${this.getKlinikId}`)
        this.dataProfile = res.data.data;
        this.nohpBefore = this.dataProfile.nomor_telp;

        this.buildProv()
        this.buildSpesialisasi()

      } catch (e) {

      }
    },
    onChangeImage(image) {
      if (image) {
        let profile = this.$store.state.user.id;
        let formData = new FormData();
        formData.set('foto_profile', this.$refs.pictureInput.file);

        this.$axios.post(`user/upload-foto/${profile}`, formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(() => {
          EventBus.$emit('image-uploaded', true);
        });
      }
    },
    disabledForm() {
      return this.formType === "detail";
    },
    async updateProses() {
      this.errors = [];

      if (!this.dataProfile.nama || !this.dataProfile.nomor_telp) {
        this.errors.push("Nama Dokter harus diisi!");
        this.$swal({
          title: "Gagal",
          text: `Silakan lengkapi kolom yang wajib diisi!`,
          type: "warning",
          confirmButtonText: startCase("ya")
        });
        return;
      }
      if (this.dataProfile.nomor_telp.length < 10 || this.dataProfile.nomor_telp.length > 15) {
        this.errors.push("Nama Dokter harus diisi!");
        this.$swal({
          title: "Gagal",
          text: `Silakan lengkapi kolom yang wajib diisi!`,
          type: "warning",
          confirmButtonText: startCase("ya")
        });
        return;
      }
      if (this.validasiNotelp === 'phone is already in use!' && this.dataProfile.nomor_telp !== this.nohpBefore) {
        this.errors.push("Nama Dokter harus diisi!");
        this.$swal({
          title: "Gagal",
          text: `Silakan lengkapi kolom yang wajib diisi!`,
          type: "warning",
          confirmButtonText: startCase("ya")
        });
        return;
      }
      if (this.dataProfile.klinik.alamat == null || this.dataProfile.klinik.alamat == '') {
        this.$swal({
          text: `Silakan lengkapi kolom yang wajib diisi!`,
          type: "error",
          showCancelButton: false,
          confirmButtonText: startCase("OK")
        });
        return;
      }
      if (!this.tempat.provinsi && !this.tempat.kota) {
        this.$swal({
          text: `Silakan lengkapi kolom yang wajib diisi!`,
          type: "error",
          showCancelButton: false,
          confirmButtonText: startCase("OK")
        });
        return;
      }
      if (this.tempat.provinsi && !this.tempat.kota) {
        this.$swal({
          text: `Silakan lengkapi kolom yang wajib diisi!`,
          type: "error",
          showCancelButton: false,
          confirmButtonText: startCase("OK")
        });
        return;
      }
      try {
        var profile = this.$store.state.user.id;
        const res = await this.$axios.put(`user/${profile}?klinik_id=${this.getKlinikId}`, {
          nama: this.dataProfile.nama,
          nomor_telp: this.dataProfile.nomor_telp,
          jenis_kelamin: this.dataProfile.jenis_kelamin,
          nomor_ijin: this.dataProfile.klinik.nomor_ijin,
          provinsi: this.tempat.provinsi && this.tempat.provinsi.id ? this.tempat.provinsi.id : null,
          kota: this.tempat.kota && this.tempat.kota.id ? this.tempat.kota.id : null,
          alamat: this.dataProfile.klinik.alamat,
          nomor_telp_engagement: this.dataProfile.klinik.nomor_telp_engagement,
          spesialisasi: this.userSpesialisasi ? this.userSpesialisasi.id : null,
        })
        if (res.data.status) {
          this.inChange === false

          this.$swal({
            type: "success",
            title: startCase("Simpan Profil"),
            text: startCase("Simpan Profil berhasil."),
          });

          this.$nextTick(() => {
            this.$router.push(`/profile`);
          });


        } else {
          this.$swal({
            title: "Gagal",
            text: `Silakan lengkapi seluruh kolom!`,
            type: "error",
            confirmButtonText: startCase("ya")
          });
        }
        this.btnDisable = true;
      } catch {

      }
    },
    setDataTempat() {
      this.dataProfile.klinik['provinsi'] = this.tempat.provinsi && this.tempat.provinsi.id ? this.tempat.provinsi
        .id : null
      this.dataProfile.klinik['kota'] = this.tempat.kota && this.tempat.kota.id ? this.tempat.kota.id : null
    },
    getProvince() {
      this.$axios.get(`province`)
        .then((response) => {
          // handle success
          this.provinces = response.data.data.provinsi.map(val => ({
            ...val,
            label: `${val.provinsi_nama}`,
          }));

          this.buildProv()
        })
        .catch((error) => {
        })
    },
    getSpesialisasi() {
      this.$axios.get(`spesialisasi`)
        .then((response) => {
          // handle success
          this.spesialisasi = response.data.data.spesialisasi.map(val => ({
            ...val,
            label: `${val.nama}`,
          }));

          this.buildSpesialisasi()
        })
        .catch((error) => {
        })
    },
    async getCity() {
      try {
        var val;
        this.tempat.kota = null;
        if (!this.tempat.provinsi || !this.tempat.provinsi.id) {
          val = '';
        } else {
          val = this.tempat.provinsi.id;
          const res = await this.$axios.get(`getcitybyprovince/${val}`)
          // handle success
          this.cities = res.data.data.kota.map(val => ({
            ...val,
            label: `${val.nama}`,
          }));

          if (this.dataProfile.klinik.kota) {
            this.cities.forEach(city => {
              if (city.id == this.dataProfile.klinik.kota) {
                this.tempat.kota = city;
              }
            });
          }
        }
      } catch (error) {
      }
    },
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n) {
        u8arr[n] = bstr.charCodeAt(n)
        n -= 1 // to make eslint happy
      }
      return new File([u8arr], filename, {
        type: mime
      })
    },
    buildProv() {
      if (this.provinces && this.dataProfile) {
        this.provinces.forEach(prov => {
          if (prov.id == this.dataProfile.klinik.provinsi) {
            this.tempat.provinsi = {
              ...prov,
              label: prov.provinsi_nama
            }
          }
        });

        if (this.tempat.provinsi && this.tempat.provinsi.id) {
          this.getCity();
        }
      }
    },
    buildSpesialisasi() {
      if (this.spesialisasi && this.dataProfile) {
        this.spesialisasi.forEach(val => {
          if (val.id == this.dataProfile.klinik.spesialisasi_id) {
            this.userSpesialisasi = {
              ...val,
              label: val.nama
            }
          }
        });
      }
    }
  }
}
</script>

<style scoped>
.badge-alert {
  background-color: #ffffff;
  border: solid 1px rgba(7, 9, 25, 0.5) !important;
  border-radius: 50%;
  cursor: pointer;
}
</style>